import {
  GET_ASSETS_CAT,
  GET_ALL_ASSETS,
  GET_ALL_REQUESTS,
  GET_ALL_EXPENDITURES,
  GET_REQUEST,
  GET_PENDING_REQUEST,
} from "../../actionTypes";

const initialState = {
  allAssets: [],
  allRequests: [],
  allPendingRequests: [],
  requestTypes: [],
  assetsCat: [],
  officeRequestsCategories: [],
  individualRequestsCategories: [],
  expenditures: [],
  request: [],
  requestCategory: [],
  requestType: [],
  next: "",
  prev: "",
  currentPage: 1,
  last: null,
};

export const orgarnizationMngtReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ASSETS_CAT:
      return {
        ...state,
        assetsCat: payload,
      };

    case GET_ALL_ASSETS:
      return {
        ...state,
        allAssets: payload.assets,
      };

    case GET_ALL_EXPENDITURES:
      return {
        ...state,
        expenditures: payload.request.expenditures,
        request: payload.request,
        requestType: payload.requestType.id,
        requestCategory: payload.request.request_category,
      };

    case GET_REQUEST:
      return {
        ...state,
        expenditure: payload,
      };

    case GET_ALL_REQUESTS:
      return {
        ...state,
        allRequests: payload.request.data,
        requestTypes: payload.requestType,
        officeRequestsCategories: payload.officeRequestsCategories,
        individualRequestsCategories: payload.individualRequestsCategories,
        next: payload.request.next_page_url,
        prev: payload.request.prev_page_url,
        last: payload.request.last_page,
        currentPage: payload.request.current_page,
      };

    case GET_PENDING_REQUEST:
      return {
        ...state,
        allRequests: payload.requests.data,
        requestTypes: payload.requestType,
        officeRequestsCategories: payload.officeRequestsCategories,
        individualRequestsCategories: payload.individualRequestsCategories,
        next: payload.request.next_page_url,
        prev: payload.request.prev_page_url,
        last: payload.request.last_page,
        currentPage: payload.request.current_page,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/organizationmanagement/orgarnization.reducers.js